import { render, staticRenderFns } from "./PowerTable.vue?vue&type=template&id=5f646260&"
import script from "./PowerTable.vue?vue&type=script&lang=js&"
export * from "./PowerTable.vue?vue&type=script&lang=js&"
import style0 from "./PowerTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports